import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStandDeactivationsInputDto, StandDeactivationCreateDto, StandDeactivationDto, StandDeactivationExcelDownloadDto, StandDeactivationUpdateDto } from '../dtos/stand-deactivation/models';

@Injectable({
  providedIn: 'root',
})
export class StandDeactivationService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: StandDeactivationCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandDeactivationDto>({
      method: 'POST',
      url: '/api/geographic/standDeactivations',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/standDeactivations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/standDeactivations',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandDeactivationDto>({
      method: 'GET',
      url: `/api/geographic/standDeactivations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/standDeactivations/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStandDeactivationsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandDeactivationDto>>({
      method: 'GET',
      url: '/api/geographic/standDeactivations',
      params: { standLocationId: input.standLocationId, isActive: input.isActive, deactivationReasonId: input.deactivationReasonId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StandDeactivationExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/standDeactivations/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, standLocationId: input.standLocationId, isActive: input.isActive, deactivationReasonId: input.deactivationReasonId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandDeactivationDto[]>({
      method: 'GET',
      url: '/api/geographic/standDeactivations/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StandDeactivationUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandDeactivationDto>({
      method: 'PUT',
      url: `/api/geographic/standDeactivations/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}